<div class="empty-content-wrapper">
  <div class="icon-container">
    <mat-icon>{{ icon() }}</mat-icon>
  </div>
  <h3 class="title">{{ title() }}</h3>
  <p class="description">{{ description() }}</p>
  <div class="actions">
    <ng-content></ng-content>
  </div>
</div>
